// Curated country + region catalog for the Roadmap form.
// Keeps the AI prompt matching deterministic (typo-free country names)
// and mirrors the education systems already enumerated in the backend
// prompt at /app/backend/server.py::ai_roadmap.
//
// Each country ships its most common admin regions/provinces/states so
// the AI produces the correct diplomas (DEP/DEC in Québec, Bac Pro in
// France, Ausbildung in Germany, etc.) without free-text guessing.

export const COUNTRY_CATALOG = [
  { code: "FR", name: "France",
    regions: ["Île-de-France", "Auvergne-Rhône-Alpes", "Provence-Alpes-Côte d'Azur", "Nouvelle-Aquitaine", "Occitanie", "Hauts-de-France", "Grand Est", "Bretagne", "Normandie", "Pays de la Loire", "Bourgogne-Franche-Comté", "Centre-Val de Loire", "Corse", "La Réunion", "Guadeloupe", "Martinique", "Guyane", "Mayotte"] },
  { code: "CA", name: "Canada",
    regions: ["Québec", "Ontario", "Colombie-Britannique", "Alberta", "Manitoba", "Saskatchewan", "Nouveau-Brunswick", "Nouvelle-Écosse", "Île-du-Prince-Édouard", "Terre-Neuve-et-Labrador", "Yukon", "Territoires du Nord-Ouest", "Nunavut"] },
  { code: "BE", name: "Belgique",
    regions: ["Bruxelles-Capitale", "Wallonie", "Flandre"] },
  { code: "CH", name: "Suisse",
    regions: ["Genève", "Vaud", "Zurich", "Berne", "Fribourg", "Neuchâtel", "Jura", "Valais", "Tessin"] },
  { code: "ES", name: "España",
    regions: ["Cataluña", "Madrid", "Andalucía", "Valencia", "Galicia", "País Vasco", "Castilla y León", "Castilla-La Mancha", "Aragón", "Canarias", "Baleares", "Murcia", "Asturias", "Navarra"] },
  { code: "PT", name: "Portugal",
    regions: ["Lisboa", "Porto", "Coimbra", "Braga", "Faro", "Aveiro"] },
  { code: "IT", name: "Italia",
    regions: ["Lombardia", "Lazio", "Campania", "Sicilia", "Veneto", "Piemonte", "Emilia-Romagna", "Toscana"] },
  { code: "DE", name: "Deutschland",
    regions: ["Bayern", "Baden-Württemberg", "Nordrhein-Westfalen", "Berlin", "Hamburg", "Hessen", "Niedersachsen", "Sachsen", "Rheinland-Pfalz", "Schleswig-Holstein", "Thüringen", "Brandenburg", "Sachsen-Anhalt", "Mecklenburg-Vorpommern", "Saarland", "Bremen"] },
  { code: "AT", name: "Österreich",
    regions: ["Wien", "Niederösterreich", "Oberösterreich", "Steiermark", "Tirol", "Kärnten", "Salzburg", "Vorarlberg", "Burgenland"] },
  { code: "GB", name: "United Kingdom",
    regions: ["England", "Scotland", "Wales", "Northern Ireland"] },
  { code: "IE", name: "Ireland",
    regions: ["Leinster", "Munster", "Connacht", "Ulster"] },
  { code: "US", name: "United States",
    regions: ["California", "Texas", "New York", "Florida", "Illinois", "Pennsylvania", "Ohio", "Georgia", "Massachusetts", "Washington", "Colorado", "Arizona", "Michigan", "Virginia", "New Jersey", "North Carolina", "Oregon"] },
  { code: "MX", name: "México",
    regions: ["Ciudad de México", "Jalisco", "Nuevo León", "Puebla", "Guanajuato", "Baja California", "Yucatán", "Quintana Roo"] },
  { code: "AR", name: "Argentina",
    regions: ["Buenos Aires", "Ciudad Autónoma de Buenos Aires", "Córdoba", "Santa Fe", "Mendoza", "Tucumán"] },
  { code: "BR", name: "Brasil",
    regions: ["São Paulo", "Rio de Janeiro", "Minas Gerais", "Bahia", "Rio Grande do Sul", "Paraná", "Pernambuco"] },
  { code: "MA", name: "Maroc",
    regions: ["Casablanca-Settat", "Rabat-Salé-Kénitra", "Marrakech-Safi", "Fès-Meknès", "Tanger-Tétouan-Al Hoceïma", "Souss-Massa"] },
  { code: "SN", name: "Sénégal",
    regions: ["Dakar", "Thiès", "Saint-Louis", "Ziguinchor", "Kaolack"] },
  { code: "CI", name: "Côte d'Ivoire",
    regions: ["Abidjan", "Yamoussoukro", "Bouaké", "San-Pédro", "Korhogo"] },
  { code: "NL", name: "Nederland",
    regions: ["Noord-Holland", "Zuid-Holland", "Utrecht", "Noord-Brabant", "Gelderland"] },
  { code: "OTHER", name: "Autre / Other",
    regions: [] },
];

export const countryByName = (name) =>
  COUNTRY_CATALOG.find((c) => c.name.toLowerCase() === (name || "").toLowerCase());
